"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerSchema = void 0;
const zod_1 = require("zod");
const sourceSchema = zod_1.z
    .object({
    url: zod_1.z.string().url().describe("URL of a source"),
    title: zod_1.z.string().describe("Title of a source").optional(),
    description: zod_1.z.string().describe("Description of a source").optional(),
})
    .strict()
    .describe("Source of an answer");
exports.answerSchema = zod_1.z
    .object({
    questionId: zod_1.z.string().uuid().describe("Unique identifier of an answered question in the format of UUID"),
    answer: zod_1.z.union([zod_1.z.boolean(), zod_1.z.null()]).describe("Yes (`true`), no (`false`) or neutral (`null`) answer to a question").optional(),
    isImportant: zod_1.z.boolean().describe("Whether a question was marked as important").optional(),
    respondent: zod_1.z.enum(["user", "candidate", "expert"]).describe("Who answered a question").optional(),
    comment: zod_1.z.string().describe("Respondent's comment to an answer").optional(),
    sources: zod_1.z.array(sourceSchema).min(1).describe("Ordered list of sources for an answer").optional(),
})
    .strict()
    .describe("Answer to a question of a calculator");
